import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-20 md:pt-40 md:pb-32 px-6 overflow-hidden" data-id="element-72">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-xl" data-id="element-74">
          <span className="text-gold font-semibold tracking-widest text-xs uppercase mb-4 block" data-id="element-75">
            Guía de Intervención de Emergencia
          </span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl leading-tight mb-6" data-id="element-76">
            El Protocolo <br className="hidden md:block" data-id="element-77" />
            <span className="text-gold italic" data-id="element-78">72 Horas</span>
          </h1>
          <p className="text-xl md:text-2xl font-serif text-navy/80 mb-6" data-id="element-79">
            Salvar tu matrimonio hoy.
          </p>
          <p className="text-charcoal-light leading-relaxed mb-10 text-lg" data-id="element-80">
            Sé exactamente por qué estás leyendo esto. Estás en ese punto donde
            el aire en tu casa se siente pesado. Quizás has pasado noches
            enteras mirando el techo mientras la persona que juró amarte duerme
            a escasos centímetros, pero se siente a kilómetros de distancia.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-81">
            <a href="#precio" onClick={e => {
            e.preventDefault();
            const target = document.getElementById('precio');
            if (!target) return;
            const startY = window.scrollY;
            const endY = target.getBoundingClientRect().top + window.scrollY;
            const distance = endY - startY;
            const duration = 3500;
            let startTime: number | null = null;
            const easeInOutQuad = (t: number) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
            const step = (timestamp: number) => {
              if (startTime === null) startTime = timestamp;
              const elapsed = timestamp - startTime;
              const progress = Math.min(elapsed / duration, 1);
              window.scrollTo(0, startY + distance * easeInOutQuad(progress));
              if (progress < 1) window.requestAnimationFrame(step);
            };
            window.requestAnimationFrame(step);
          }} className="bg-navy text-cream px-8 py-4 rounded-sm font-medium hover:bg-navy-light transition-colors duration-300 inline-flex items-center gap-2 group cursor-pointer" data-id="element-82">
              Empezar el Protocolo
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-83" />
            </a>
            <a href="#historia" className="text-navy hover:text-gold transition-colors font-medium underline underline-offset-4 decoration-navy/30 hover:decoration-gold" data-id="element-84">
              Leer la historia de Thomas
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-85">
          <div className="absolute inset-0 bg-gold/10 rounded-2xl transform translate-x-4 translate-y-4 -z-10" data-id="element-86"></div>
          <img src="https://cdn.magicpatterns.com/uploads/jnEE7ck5iZ7LUzmh6G5vr4/heylloyd-image-1778960312133.png" alt="El Protocolo 72 Horas en tablet" className="w-full h-auto rounded-xl shadow-2xl object-cover" data-id="element-87" />
          <div className="mt-8 text-center" data-id="element-88">
            <p className="font-serif italic text-xl text-navy/70" data-id="element-89">
              "No es el final de tu historia."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}